import reduceReducers from 'reduce-reducers';

import viewReducer from './view-reducer';

export default reduceReducers(viewReducer);
